import { Box, Checkbox, Grid, IconButton, ImageList, ImageListItem, Modal, Paper, SpeedDial, SpeedDialAction, SpeedDialIcon, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import Sidebar from "./Sidebar";
import axios from 'axios';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddAPhoto, AddToPhotos, CheckBox, Delete } from "@mui/icons-material";
import "./Gallery.css";
const position = {
    width: '40%',
    height: 400,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    background: 'white',
    borderRadius: 5
}
export default function Gallery() {

    var navi = useNavigate();
    const [shopId, setshopID] = useState();
    function CheckLogIn() {

        var id = localStorage.getItem('uuid');
        if (!id) {
            navi('/')
        } else {
            setshopID(id);
        }

    }

    useEffect(() => {
        CheckLogIn();
    }, [])

    const [salonData, setSalonData] = useState();
    const [currentFeaturedImages, setCurrentFeaturedImages] = useState([null, null, null, null]);

    // function fetchSalon() {
    //     if (!shopId) {
    //         return;
    //     }
    //     axios.post(url + 'getShop', {
    //         Id: shopId
    //     }).then((succ) => {
    //         if (succ.data.response != 'failed') {
    //             setSalonData(succ.data);
    //             // console.log((succ.data?.FeaturedImages.length > 0));
    //             if (succ.data?.FeaturedImages.length > 0) {
    //                 setCurrentFeaturedImages(succ.data.FeaturedImages)
    //             }

    //         }
    //     })
    // }
    const [galleryImages, setGalleryImages] = useState([]);
    function fetchSalon() {

        if (!shopId) return;

        axios.post(url + "getShop", {
            Id: shopId
        }).then((succ) => {

            if (succ.data.response !== "failed") {

                setSalonData(succ.data);

                if (
                    succ.data.FeaturedImages &&
                    succ.data.FeaturedImages.length > 0
                ) {

                    const imgs = (succ.data.FeaturedImages || []).map(
                        item => item?.url || null
                    );
                    setCurrentFeaturedImages(imgs);
                }

                setGalleryImages(succ.data.Gallery)
                // console.log('FeaturedImages!', succ.data.FeaturedImages.length);
                console.log(succ.data);
            }
        });
    }
    useEffect(() => {
        fetchSalon();
    }, [shopId])

    var url = `http://localhost:${process.env?.PORT || 3000}/`
    var uuid = localStorage.getItem('uuid')

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [modal, setmodal] = useState(false);
    const handleModalOpen = () => {
        setmodal(!modal);
    }
    const handleGalleryOpen = () => {
        console.log('ok')
    }

    const [profile, setprofile] = useState(null);
    // const handleFileChange = (e) => {
    //     const selectedFile = url.createObjectURL(e.target.files[0]);
    //     setprofile(selectedFile);

    //     console.log(profile)

    //     const formdata = new FormData();
    //     formdata.append('image', selectedFile);
    //     console.log(formdata)
    // }

    // const [featuredImages, setFeaturedImages] = useState([null, null, null, null]);
    // const handleFileChange = (index, file) => {
    //     const imgs = [...featuredImages];
    //     imgs[index] = file;
    //     setFeaturedImages(imgs);
    // }
    const handleFileChange = async (
        index,
        file
    ) => {

        if (!file) return;

        try {

            const formData = new FormData();

            formData.append("image", file);
            formData.append("salonId", shopId);
            formData.append("index", index);

            const response = await axios.post(
                url + "updateFeaturedImage",
                formData,
                {
                    headers: {
                        "Content-Type":
                            "multipart/form-data"
                    }
                }
            );

            if (response.data === "ok") {

                setCurrentFeaturedImages(prev => {

                    const updated = [...prev];

                    updated[index] =
                        URL.createObjectURL(file);

                    return updated;
                });

                fetchSalon();
            }

        } catch (err) {

            console.log(err);
            alert("Upload failed");
        }
    };
    // function submitImgs() {
    //     const data = new FormData();
    //     featuredImages.forEach((file, index) => {
    //         console.log(index, file);
    //     });
    //     featuredImages.forEach((file) => {
    //         if (!file) {
    //             return
    //         }
    //         data.append('featuredImages', file);
    //     })

    //     data.append("salonId", '69bd5cf3dec2d7b7ee66bcfe');

    //     axios.post(url + "saveFeaturedImages", data).then((succ) => {
    //         if (succ.data.response == 'failed') {
    //             alert(succ.data.reason);
    //         } else {
    //             console.log(succ.data.result);
    //             fetchSalon();
    //         }
    //     })

    // }



    function addImageToGallery(e) {
        e.preventDefault();
        var data = new FormData();
        var file = data.get('file')
        // console.log(file)
        data.append("File", e.target.file.files[0])
        data.append("Id", uuid)
        axios.post(url + 'gallery/add/image', data).then((succ) => {
            // console.log(succ.data);
            fetchSalon();
        })
    }

    // function deleteImageFromGallery(img) {
    //     try {
    //         axios.post(url + 'gallery/delete/image', {
    //             Id: uuid,
    //             ImageUrl: img
    //         }).then((succ) => {
    //             if (succ.data.response == 'failed') {
    //                 alert(succ.data.reason);
    //             } else {
    //                 fetchSalon();
    //             }
    //         })
    //     } catch (error) {
    //         alert('failed to delete image. Reason:', error)
    //     }

    // }
    const [selectedImages, setSelectedImages] = useState([])

    function deleteSelectedImages() {
        if (selectedImages.length === 0) {
            alert('no images selected.');
        } else {
            try {
                axios.post(url + 'gallery/delete/image', {
                    Id: uuid,
                    ImageUrl: selectedImages
                }).then((succ) => {
                    if (succ.data.response == 'failed') {
                        alert(succ.data.reason);
                    } else {
                        console.log('success');
                        fetchSalon();
                        setSelectedImages([]);
                    }
                })
                // console.log({
                //     Id:uuid,
                //     ImageUrl:selectedImages
                // })
            } catch (error) {
                alert('something went wrong.')
            }
        }
    }


    function addImageToArray(e) {
        if (e.target.checked) {
            setSelectedImages(prev => [...prev, e.target.value]);
        } else {
            setSelectedImages(prev =>
                prev.filter(img => img !== e.target.value)
            );
        }
    }
    useEffect(() => {
        console.log(selectedImages)
    }, [selectedImages])

    return (
        <>

            <Grid container height={'100vh'} className='admin-Section' width={'100%'}>
                <Sidebar />
                <Grid height={'100%'} size={{ xs: 9.6 }} p={3}>
                    <Grid container justifyContent={'space-between'}>
                        {/* <Grid className='admin-section '> */}
                        {/* <Grid size={{ lg: 5.5 }} p={2} className='admin-section shadow'>
                            <Typography variant="h4">Add Image</Typography>
                            <form onSubmit={addImage}>
                                <input type="file" name="image" className="form-control mt-3" accept=".jpeg,.jpg,.png,.avif,.webp" />
                                <button type="submit" className="btn btn-danger w-100 mt-2">Submit</button>
                            </form>
                        </Grid> */}
                        {/* <Grid className='admin-section shadow px-3 mt-3' size={{ lg: 12 }} p={2}>
                            <ImageList className="w-100" cols={3} rowHeight={164}>
                                {gallery.map((item, index) => (
                                    <ImageListItem key={index}>
                                        <img
                                            srcSet={`${item}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}

                                            src={`${item}?w=164&h=164&fit=crop&auto=format`}
                                            alt={'Gallery Image'}
                                            loading="lazy"
                                        />
                                    </ImageListItem>
                                ))}
                            </ImageList>
                        </Grid> */}
                        {/* </Grid> */}
                        <div className='image-gallery-cont'>
                            {currentFeaturedImages.map((row, index) => (

                                <>
                                    <div className={index == 0 ? 'wide-img img-cont' : index == 1 ? 'small-img1 img-cont' : index == 2 ? 'small-img2 img-cont' : 'last-img img-cont'}>
                                        <img
                                            src={row || require('./imgs/placeholder.avif')}
                                            className="gallery-img"
                                        />
                                        <div className='image-wrap text-white'>
                                            <label htmlFor={`img${index}`} className="cursor-pointer row m-0 align-items-center h-100 w-100">
                                                <Typography textAlign={'center'} variant="h4">Change</Typography>
                                            </label>
                                            <input onChange={(e) => handleFileChange(index, e.target.files[0])} type="file" accept=".jpeg,.jpg,.webp,.png,.avif" id={`img${index}`} className="d-none" />
                                        </div>
                                    </div>
                                </>
                            ))}
                        </div>

                        <Grid container mt={3} justifyContent={'space-between'} alignItems={'flex-start'} width={'100%'}>
                            <div className="card rounded col-lg-4">
                                <div className="card-body">
                                    <form onSubmit={addImageToGallery}>
                                        <Typography variant="h6">Add Image</Typography>
                                        <input accept=".jpg,.jpeg,.avif,.webp,.png" type="file" className="form-control mt-3" name="file" />
                                        <button type="submit" className="btn btn-navy mt-3 w-100">Submit</button>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-7 rounded bg-white p-3">
                                <Grid container justifyContent={'space-between'}>
                                    <Typography variant="h4">Gallery:</Typography>
                                    <IconButton disabled={selectedImages.length === 0} onClick={() => deleteSelectedImages()} size="medium">
                                        <Delete />
                                    </IconButton>
                                </Grid>
                                <Grid maxHeight={350} sx={{overflowY:'auto'}} className='salon_gallery_cont mt-3'>
                                    {galleryImages?.length > 0 ? (
                                        galleryImages.map((row) => (
                                            <div
                                            //  onClick={() => deleteImageFromGallery(row)}
                                            >
                                                <img src={row} alt={'Gallery Image'} className='' />
                                                <div className="text-wrapper"></div>
                                                <Checkbox value={row} checked={selectedImages.includes(row)} onChange={(e) => addImageToArray(e)} sx={{ zIndex: 5, color: 'white' }} className="checkbox" />
                                            </div>
                                        ))
                                    ) : (
                                        <Typography variant="h6" className="w-100">You don't have any images added.</Typography>
                                    )}
                                </Grid>
                            </div>
                        </Grid>


                    </Grid>
                </Grid>
                <SpeedDial
                    ariaLabel="SpeedDial controlled open example"
                    sx={{ position: 'absolute', bottom: 16, right: 16 }}
                    icon={<SpeedDialIcon />}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    open={open}
                >
                    {/* {actions.map((action) => ( */}
                    <SpeedDialAction
                        // key={action.name}
                        icon={<AddAPhoto />}
                        slotProps={{
                            tooltip: {
                                title: 'edit your primary picture',
                            },
                        }}
                        onClick={handleModalOpen}
                    />
                    <SpeedDialAction
                        // key={action.name}
                        icon={<AddToPhotos />}
                        slotProps={{
                            tooltip: {
                                title: 'add photos to your gallery',
                            },
                        }}
                        onClick={handleGalleryOpen}
                    />
                    {/* ))} */}
                </SpeedDial>
                <Modal open={modal} onClose={handleModalOpen}>
                    <Paper sx={[position, { padding: 3 }]}>
                        <Typography variant="h6">Select Photo</Typography>
                        <form>
                            <input onChange={handleFileChange} type="file" className="form-control mt-2" name="file" />
                            {profile ? (
                                <img src={profile} className="upload-img mt-4" />
                            ) : (
                                <>
                                    <AddAPhoto sx={{ fontSize: 133 }} /><Typography ml={1.5} variant="h4">Add Image</Typography>
                                </>
                            )}
                        </form>
                        <button className="btn btn-danger w-100 mt-4">Edit Your Profile Picture</button>
                    </Paper>
                </Modal>
            </Grid>
        </>
    )

}